import {
 useMutation
}
from '@tanstack/react-query';

import toast
from 'react-hot-toast';

import {
 tourServices
}
from '../services/tour.service';



export const
useUploadTourVideo =
()=>{

 return useMutation({

   mutationFn:
   async(file)=>{

      return await
      tourServices
      .uploadVideo(
         file
      );

   },

   onError:()=>{

      toast.error(
        'Upload failed'
      );

   }

 });

};